export const strings = {
  common: {
    yes: 'Taip',
    no: 'Ne',
    home: 'Pradžia',
    searchLabel: 'Ieškoti',
    searchKeywordsLabel: 'Ieškoti tarp raktažodžių',
    successfullyUpdated: 'Sėkmingai atnaujinta',
    button: {
      edit: 'Redaguoti',
      save: 'Išsaugoti',
      exit: 'Išeiti',
      selectAllPhotos: 'Pažymėti visas nuotraukas',
    },
    filter: {
      dateRange: 'Laikotarpis',
    },
    pagination: {
      previous: 'Praeitas',
      next: 'Kitas',
      showing: 'Rodoma',
      from: 'nuo',
      to: 'iki',
      of: 'iš',
      items: 'įrašų',
    },
    confirmation: {
      deleteCompany: {
        title: 'Ar tikrai norite ištrinti šią įmonę?',
        description:
          'Trinant įmonę kartu bus ištrinti visi įmonės vartotojai ir jie nebegalės prisijungti. Taip pat po ištrynimo nebus galimybės sugrąžinti atgal ištrintos informacijos.',
      },
      deleteFile: {
        title: 'Ar tikrai norite ištrinti šį dokumentą?',
        description: 'Ištrynus jį, nebebus įmanoma sugrąžinti atgal.',
      },
      deleteUser: {
        title: 'Ar tikrai norite ištrinti šį vartotoją?',
        description: 'Ištrynus jį, nebebus įmanoma sugrąžinti atgal.',
      },
      deleteBadge: {
        title: 'Ar tikrai norite ištrinti šį ženkliuką?',
        description: 'Ištrynus jį, nebebus įmanoma sugrąžinti atgal.',
      },
      deleteTranslation: {
        title: 'Ar tikrai norite ištrinti šį vertimą?',
        description: 'Ištrynus jį, nebebus įmanoma sugrąžinti atgal.',
      },
      deleteCategory: {
        title: 'Ar tikrai norite ištrinti šią kategoriją?',
        description: 'Ištrynus kategoriją, jos nebebus galima sugrąžinti.',
      },
    },
  },
  companies: {
    registered: 'Registracijos data',
    demo: 'Demo',
    active: 'Aktyvus',
    name: 'Pavadinimas',
    subscription: 'Prenumerata',
    expires_at: 'Galioja iki',
    news_subscription: 'Naujienų prenumerata',
    press_releases: 'Pranešimai spaudai',
    services: {
      disableServiceTooltip: 'Norėdami išjungti paslaugą, ištrinkite jos galiojimo laiką',
      premiumVideo: 'Premium video',
      eltaSense: 'Elta Sense',
      photos: {
        title: 'Nuotraukų prenumerata (Fotobankas)',
        subscriptionStart: 'Nuotraukų prenumeratos pradžia',
        subscriptionEnd: 'Nuotraukų prenumeratos pabaiga',
        monthlyLimit: 'Nuotraukų kiekis (per mėnesį)',
        remainingThisMonth: 'Nuotraukų likutis (šį mėnesį):',
        unlimitedHint: 'Jeigu reikia neriboti - palikite tuščia lauką',
        allowOlderThan2010: 'Leisti siųstis senesnes nei nuo 2010 m.',
        allowDownloadFrom: 'Leisti siųstis nuo:',
        unlimitedDownloadHint: 'Jeigu reikia leisti siųstis neribojant laiko - palikite tuščią lauką',
      },
    },
    filter: {
      loginState: 'Prisijungimas',
      serviceState: 'Paslaugų statusas',
      service: 'Aktyvi paslauga',
      companyType: 'Tipas',
      subscriptionExpirationDate: 'Prenumerata galioja iki',
      pressReleaseExpirationDate: 'Pranešimai spaudai galioja iki',
      activeFilters: 'filtras|filtrai|filtrų',
      select: 'Filtrai',
      selectsValues: {
        service: {
          subscription: 'Prenumerata',
          press_releases: 'Pranešimai spaudai',
        },
        loginState: {
          active: 'Aktyvus',
          inactive: 'Neaktyvus',
        },
        serviceState: {
          all: 'Visi',
          active: 'Aktyvus',
          inactive: 'Neaktyvus',
        },
      },
    },
  },
  error: {
    fieldIsRequired: 'Laukas yra privalomas',
    companyNamedIsRequired: 'Įmonės pavadinimas privalomas',
    pageNotFound: {
      title: 'Puslapis nerastas',
      description: 'Patikrinkite adresą arba bandykite dar kartą.',
      goHome: 'Grįžti į pradžią',
    },
  },
  form: {
    email: 'El.pašto adresas',
    password: 'Slaptažodis',
    error: {
      emailFormat: 'Įvestas tekstas enatitinka el. pašto formato',
      required: 'Laukas privalomas',
      categoryRequired: 'Pasirinkite temą',
    },
  },
  filter: {
    clearFilter: 'Išvalyti',
  },
  button: {
    login: 'Prisijungti',
    close: 'Uždaryti',
    edit: 'Redaguoti',
    view: 'Peržiūrėti',
    delete: 'Ištrinti',
    pin: 'Pažymėti',
    unpin: 'Atžymėti',
    save: 'Išsaugoti',
    comment: 'Komentuoti',
    cancel: 'Atšaukti',
    removeAll: 'Remove All',
    create: 'Sukurti',
    translate: 'Versti',
    publish: 'Publikuoti',
    download: 'Atsisiųsti',
    downloading: 'Siunčiama..',
    downloadMarketingUsers: 'Atsisiųsti rinkodaros vartotojus',
    preview: 'Peržiūrėti',
    clearPhotos: 'Pašalinti nuotraukas',
    createAlbum: 'Sukurti albumą',
    addToAlbum: 'Pridėti prie albumo',
  },
  navigation: {
    groups: 'Pagrindinės skiltys',
    section: 'Skilties puslapiai',
    openSidebar: 'Atidaryti meniu',
    closeSidebar: 'Uždaryti meniu',
    userMenu: 'Vartotojo meniu',
    media: 'Medija',
    admin: 'Admin',
    localPhotos: 'Lietuvos nuotraukos',
    foreignPhotos: 'Užsienio nuotraukos',
    video: 'Video',
    pressreleases: 'Pranešimai spaudai',
    preparing: 'Ruošiamos',
    scheduled: 'Atidėtos',
    published: 'Publikuotos',
    agencies: 'Agentūros',
    publicNews: 'ELTA žinios visiems',
    trash: 'Šiukšliadėžė',
    returnToMainAdmin: 'Grįžti į seną versiją',
    clients: 'Klientai',
    news: 'Naujienos',
    management: 'Valdymas',
    companies: 'Įmonės',
    users: 'Vartotojai',
    employees: 'Darbuotojai',
    badges: 'Ženkliukai',
    translations: 'Vertimai',
    photos: 'Nuotraukos',
    easyToRead: 'ELTA E2R',
    uploadPhotos: 'Įkelti nuotraukas',
    lt: 'Lietuvos',
    foreign: 'Užsienio',
    photosInPreparation: 'Ruošiamos nuotraukos',
    photosforeignAgencies: 'Užsienio agentūrų nuotraukos',
    photoAlbums: 'Albumai',
    signOut: 'Atsijungti',
    reports: {
      title: 'Ataskaitos',
      content: 'Turinio ataskaita',
      usage: 'Klientų atsisiuntimai/peržiūros',
      pressreleaseStats: 'PS ataskaita',
      logs: 'Veiksmų žurnalas',
    },
  },
  search: {
    noResults: 'Nerasta jokių įrašų',
  },
  logs: {
    filters: {
      dateRange: 'Laikotarpis',
      user: 'Vartotojas',
      ip: 'IP adresas',
      userPlaceholder: 'Ieškoti pagal vartotoją',
      ipPlaceholder: 'Ieškoti pagal IP adresą',
    },
    columns: {
      createdAt: 'Laikas',
      user: 'Vartotojas',
      ip: 'IP adresas',
      action: 'Veiksmas',
    },
  },
  badges: {
    title: 'Ženkliukai',
    createTitle: 'Sukurti naują ženkliuką',
    editTitle: 'Redaguoti ženkliuką',
    messages: {
      saved: 'Ženkliuko informacija sėkmingai išsaugota',
    },
    list: {
      untitled: 'Be pavadinimo',
      noActiveLanguages: 'Neaktyvus',
      columns: {
        title: 'Pavadinimas',
        color: 'Spalva',
        activeLanguages: 'Aktyvios kalbos',
      },
    },
    form: {
      sharedSettings: 'Bendri nustatymai',
      translations: 'Vertimai',
      title: 'Pavadinimas',
      comment: 'Komentaras',
      color: 'Spalva',
      openColorPicker: 'Pasirinkti spalvą',
      active: 'Aktyvus',
      private: 'Privatus',
      changeRenewalDate: 'Keisti atnaujinimo datą',
    },
  },
  translations: {
    title: 'Vertimai',
    createTitle: 'Sukurti vertimą',
    editTitle: 'Redaguoti vertimą',
    missing: 'Trūksta vertimo',
    form: {
      general: 'Bendri nustatymai',
      key: 'Raktas',
      keyRequired: 'Raktas privalomas',
      translations: 'Vertimai',
      value: 'Vertimas',
    },
  },
  categories: {
    title: 'Kategorijos',
    createTitle: 'Sukurti kategoriją',
    editTitle: 'Redaguoti kategoriją',
    filters: {
      language: 'Kalba',
      type: 'Tipas',
    },
    columns: {
      name: 'Pavadinimas',
      type: 'Tipas',
      abbreviation: 'Trumpinys',
      abbreviationForeign: 'Trumpinys (užsienis)',
    },
    types: {
      news: 'Naujienos',
      eltaGuide: 'ELTA gidas',
      expectedEvents: 'Numatomi įvykiai',
    },
    visibility: {
      news: 'Naujienos',
      photos: 'Nuotraukos',
      pressreleases: 'Pranešimai spaudai',
    },
    form: {
      language: 'Kalba',
      type: 'Tipas',
      name: 'Pavadinimas',
      nameRequired: 'Kategorijos pavadinimas privalomas',
      parent: 'Priklauso kategorijai',
      noParent: 'Pagrindinė kategorija',
      abbreviation: 'Trumpinys (Lietuva)',
      abbreviationForeign: 'Trumpinys (užsienis)',
      description: 'Aprašymas',
      active: 'Aktyvi',
      homepage: 'Rodyti pagrindiniame puslapyje',
      visibility: 'Matomumas',
      sortOrder: 'Eilės tvarka',
      bulletinSortOrder: 'Eilės tvarka biuletenyje',
      assignToAllCustomers: 'Priskirti naują kategoriją visiems klientams',
    },
  },
  users: {
    list: {
      email: 'El. paštas',
      name: 'Vardas',
      company: 'Įmonė',
      noEmail: 'Be el. pašto',
    },
  },
  employees: {
    title: 'Darbuotojai',
    createTitle: 'Sukurti naują darbuotoją',
    editTitle: 'Redaguoti darbuotoją',
    messages: {
      saved: 'Darbuotojo informacija sėkmingai išsaugota',
    },
    form: {
      firstName: 'Vardas',
      lastName: 'Pavardė',
      username: 'Prisijungimo vardas',
      email: 'El. pašto adresas',
      position: 'Pareigos',
      phone: 'Kontaktinis telefonas',
      password: 'Slaptažodis',
      passwordOptional: 'Slaptažodis (neprivaloma)',
      passwordConfirmation: 'Pakartokite slaptažodį',
      comments: 'Pastabos ir komentarai',
      active: 'Leidžiama prisijungti',
      group: 'Leidžiama prisijungti iš kelių įrenginių vienu metu (Grupinis)',
      roles: 'Rolės',
      ipRanges: 'IP adresų rėžiai iš kurių galima prisijungti',
      addIpRange: 'Pridėti IP rėžį',
    },
    roles: {
      admin: 'Administratorius',
      contentmanager: 'Turinio tvarkytojas',
      manager: 'Vadybininkas',
      editor: 'Redaktorius',
      photoeditor: 'Fotoredaktorius',
      translator: 'Vertėjas',
      photographer: 'Fotografas',
      journalist: 'Žurnalistas',
      journalistJunior: 'Žurnalistas naujokas',
    },
  },
  easyToRead: {
    description:
      'Įkelkite naujienos tekstą, išsiųskite jį konvertavimui ir dešinėje stebėkite sugeneruotą HTML peržiūrą.',
    requests: 'Užklausos',
    requestsHint: 'Rodomos 30 naujausių užklausų.',
    newRequest: 'Nauja užklausa',
    sourceText: 'Pradinis tekstas',
    sourceHint: 'Įklijuokite visą naujienos tekstą, kurį reikia konvertuoti.',
    sourceTitle: 'Pradinis pavadinimas',
    titlePlaceholder: 'Įveskite naujienos pavadinimą...',
    placeholder: 'Įklijuokite tekstą čia...',
    minimumLength: 'Tekstas turi būti bent 10 simbolių ilgio.',
    convert: 'Konvertuoti',
    preview: 'Sugeneruota peržiūra',
    previewHint: 'HTML formatavimas rodomas taip, kaip bus gauta iš API.',
    downloadWord: 'Atsisiųsti kaip Word',
    noRequests: 'Dar nėra nė vienos užklausos.',
    noSelection: 'Pasirinkite užklausą kairėje arba sukurkite naują.',
    queuedMessage: 'Turinys įtrauktas į eilę. Laukiama konvertavimo atsakymo.',
    deletedMessage: 'Užklausa pašalinta iš sąrašo.',
    waitingTitle: 'Laukiama atsakymo',
    waitingText: 'Turinys jau išsiųstas. Kai API grąžins rezultatą, peržiūra atsinaujins automatiškai.',
    failedTitle: 'Konvertavimas nepavyko',
    retry: 'Kartoti konvertavimą',
    createdBy: 'Sukūrė',
    createdAt: 'Sukurta',
    unknownCreator: 'Nenurodytas vartotojas',
    generatedTitle: 'Sugeneruotas pavadinimas',
    generatedBody: 'Sugeneruotas tekstas',
    noPreview: 'Peržiūros dar nėra.',
  },
  payments: {
    periodicityOptions: {
      monthly: 'Kas mėnesį',
      singleUse: 'Vienkartinis',
      individual: 'Individualus',
    },
    invoiceBy: {
      invoice_email: 'El. paštu',
      invoice_einvoice: 'E. sąskaita faktūra',
    },
  },
  documents: {
    types: {
      contract: 'Sutartis',
      appendix: 'Priedas',
      other: 'Kita',
    },
  },
  photos: {
    filter: {
      state: {
        title: 'Nuotraukų būsena',
        active: 'Publikuotos',
        inactive: 'Ruošiamos',
      },
      category: {
        title: 'Temos',
      },
      subCategory: {
        title: 'Potemė',
      },
      language: 'Pasirinkite kalbą',
      date: 'Nuotraukos įkėlimo data',
      author: 'Ieškoti pagal autorių',
    },
    backToList: 'Grįžti į nuotraukų sąraša',
    header: {
      upload: 'Nuotraukų įkėlimas',
      list: 'Nuotraukos',
      edit: 'Nuotraukų redagavimas',
      translate: 'Nuotraukų vertimas',
      photosList: {
        translate: 'Photos to translate',
        edit: 'Photos to edit',
      },
    },
    list: {
      empty: 'Deja, bet dar nėra įkeltų nuotraukų',
      missingRequiredFields: 'Pasirinktų nuotraukų sąraše yra nuotraukų/-a, be privalomos informacijos.',
    },
    modal: {
      deletePhotos: {
        title: 'Ar tikrai norite ištrinti pasirinktas nuotraukas?',
        text: 'Paspaudus myktuką "Taip", nuotraukos bus negrįžtamai ištrintos.',
        albumTitle: 'Kaip norite pašalinti pasirinktas nuotraukas?',
        albumText:
          'Pasirinktos nuotraukos priklauso {albums}. Pasirinkite, ar pašalinti jas tik iš albumų, ar visiškai ištrinti.',
        albumCount: 'albumui|albumams|albumų',
        removeFromAlbums: 'Pašalinti tik iš albumų',
        removeFromCurrentAlbum: 'Pašalinti tik iš šio albumo',
        deleteCompletely: 'Visiškai ištrinti',
        removeConfirmationTitle: 'Ar tikrai norite pašalinti pasirinktas nuotraukas iš albumų?',
        removeConfirmationText: 'Nuotraukos bus pašalintos iš albumų, tačiau liks fotobanke.',
        removeCurrentAlbumConfirmationTitle: 'Ar tikrai norite pašalinti pasirinktas nuotraukas iš šio albumo?',
        removeCurrentAlbumConfirmationText:
          'Nuotraukos bus pašalintos tik iš šio albumo, nebus pašalintos iš kitų albumų ir liks fotobanke.',
      },
    },
    edit: {
      form: {
        published: 'Publikuota:',
        publishPhoto: 'Publikuoti nuotraukas po išsaugojimo',
        title: 'Autorystė',
        titleSecondary: 'Pavadinimas',
        description: 'Aprašymas',
        keywords: 'Raktažodžiai',
        country: 'Šalis',
        language: 'Kalba',
        author: 'Autorius',
        category: 'Tema',
        subcategory: 'Potemė',
        categories: 'Temos',
        subcategories: 'Potemės',
        placeholder: {
          country: 'Pasirinkite šalį',
          author: 'Pasirinkite autorių',
          category: 'Pasirinkite temą',
          subcategory: 'Pasirinkite potemę',
        },
        addCategory: 'Pridėti kategoriją',
        errors: {
          maxLength: 'Maksimalus teksto ilgis - 300 simboliai.',
          oneKeyword: 'Įveskite bent vieną raktažodį',
          noPhoto: 'Deja, bet tokios nuotraukos nėra',
          noSubcategory: 'Ši tema neturi potėmių',
          fillRequired: 'Neužpildėte visų privalomų laukų',
        },
      },
      modal: {
        copyValues: {
          title: 'Ar tikrai norite kopijuoti laukelio reikšmę?',
          text: 'Paspaudus myktuką "Taip", pasirinkto laukelio tekstas bus nukuopijuotas į visus jį atitinkančius laukelius.',
        },
      },
    },
    dropzone: {
      selectPhotos: {
        firstRow: 'Pasirinkite įkeliamas nuotraukas arba nutempkite jas į šitą plotą',
        button: 'Rinktis nuotraukas',
      },
      buttons: {
        continueWithPhotos: 'Tęsti su įkeltomis nuotraukomis',
        saveAndContinue: ' Išsaugoti ir tęsti',
        saveAndExit: ' Išsaugoti ir išeiti',
        exit: ' Išeiti',
      },
    },
  },
  videos: {
    player: {
      Play: 'Groti',
      Pause: 'Pristabdyti',
      Replay: 'Groti iš naujo',
      'Current Time': 'Dabartinis laikas',
      Duration: 'Trukmė',
      'Remaining Time': 'Likęs laikas',
      'Stream Type': 'Srauto tipas',
      LIVE: 'TIESIOGIAI',
      Loaded: 'Įkelta',
      Progress: 'Eiga',
      'Progress Bar': 'Eigos juosta',
      Fullscreen: 'Visas ekranas',
      'Exit Fullscreen': 'Išeiti iš viso ekrano',
      Mute: 'Nutildyti',
      Unmute: 'Įjungti garsą',
      'Playback Rate': 'Atkūrimo greitis',
      'Volume Level': 'Garsumas',
      'Picture-in-Picture': 'Vaizdas vaizde',
      'Exit Picture-in-Picture': 'Išeiti iš vaizdo vaizde',
      'Skip forward {1} seconds': 'Pirmyn {1} sekundžių',
      'Skip backward {1} seconds': 'Atgal {1} sekundžių',
      'No compatible source was found for this media.': 'Vaizdo įrašas šiuo metu nepasiekiamas.',
      'The media could not be loaded, either because the server or network failed or because the format is not supported.':
        'Nepavyko įkelti vaizdo įrašo.',
      'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.':
        'Nepavyko atkurti vaizdo įrašo.',
    },
    sort: 'Rikiuoti',
    newest: 'Naujausi',
    oldest: 'Seniausi',
    byTitle: 'Pagal pavadinimą',
    search: 'Ieškoti',
    empty: 'Vaizdo įrašų nerasta.',
    unknownDate: 'Data nenurodyta',
    unavailable: 'Vaizdo įrašas šiuo metu nepasiekiamas.',
    notFound: 'Vaizdo įrašas nerastas.',
    back: 'Grįžti į vaizdo įrašus',
    copyLink: 'Kopijuoti nuorodą',
    linkCopied: 'Nuoroda nukopijuota.',
    copyFailed: 'Nepavyko nukopijuoti nuorodos. Nukopijuokite ją iš naršyklės adreso juostos.',
  },
  albums: {
    filter: {
      state: {
        title: 'Albumo būsena',
        active: 'Publikuoti',
        inactive: 'Ruošiami',
      },
      category: {
        title: 'Temos',
      },
      subCategory: {
        title: 'Potemė',
      },
      date: 'Albumo sukūrimo data',
    },
  },

  album: {
    created: 'Sukurta:',
    published: 'Publikuota:',
    photosCount: 'Nuotraukos',
    filter: {
      selected: 'Pasirinkta nuotraukų:',
    },
    fromPhotos: {
      createTitle: 'Sukurti albumą iš nuotraukų',
      addTitle: 'Pridėti nuotraukas į albumą',
      addSuccess: 'Nuotraukos pridėtos į albumą',
      createSuccess: 'Albumas sėkmingai sukurtas',
      publishAfterSave: 'Publikuoti po išsaugojimo',
      latestAlbumsNotice: 'Rodomi 50 naujausių albumų. Jei ieškote konkretaus albumo, naudokite paiešką.',
    },
    header: {
      upload: 'Įkelkite nuotraukas',
      title: 'Albumas:',
    },
    modal: {
      title: 'Sukurti Albumą',
      editTitle: 'Redaguoti albumą',
      delete: {
        title: 'Ištrinti albumą?',
        description:
          'Šis albumas turi priskirtų nuotraukų. Pasirinkite ar reikėtų nuotraukas ištrinti kartu su albumu, ar palikti publikuotas tačiau nepriskirtas jokiam albumui',
        confirmDeleteAll: 'Kartu ištrinti nuotraukas',
        confirm: 'Palikti nuotraukas be albumo',
      },
    },
    buttons: {
      addPhotos: 'Įkelti nuotraukas',
    },
    form: {
      label: {
        title: 'Pavadinimas',
      },
      alert: {
        success: 'Albumas sėkmingai sukurtas',
      },
    },
  },
  newsPostsStats: {
    authors: 'Autorius',
    total: 'Viso',
  },
  usageReport: {
    client: 'Klientas',
    photosEltaDownloads: 'Photos ELTA atsisiųsta',
    photosEpaDownloads: 'Photos EPA atsisiųsta',
    videosViews: 'Video peržiūros',
    videosDownloads: 'Video atsisiuntimai',
    total: 'Iš viso',
  },
  pressreleaseStats: {
    year: 'Metai',
    count: 'Pranešimų spaudai kiekis',
    total: 'Iš viso',
  },
};
